export default {
  thereAreNoItems: 'There are no items matching the specified filters.',
};
